var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "categories-selector" },
    [
      _c("VRadioGroup", {
        attrs: { name: "selectedCategoryId" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ on, attrs }) {
              return _vm._l(_vm.categories, function (category) {
                return _c(
                  "div",
                  {
                    key: category.id,
                    staticClass: "categories-selector__category",
                  },
                  [
                    _c(
                      "VRadioButton",
                      _vm._g(
                        _vm._b(
                          { attrs: { value: category.id } },
                          "VRadioButton",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "categories-selector__category-content",
                          },
                          [
                            _c("img", {
                              attrs: { src: `${category.image}`, alt: "" },
                            }),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "categories-selector__category-header",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "categories-selector__category-name",
                                  },
                                  [_vm._v(_vm._s(category.name))]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "categories-selector__category-description",
                                  },
                                  [_vm._v(_vm._s(category.description))]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm.selectedCategoryId === category.id
                      ? _c(
                          "div",
                          { staticClass: "categories-selector__category-tags" },
                          [
                            _c(
                              "p",
                              {
                                staticClass: "categories-selector__tags-title",
                              },
                              [_vm._v(_vm._s(_vm.translations.tagsTitle.text))]
                            ),
                            _c("CategoriesFormTags", {
                              attrs: {
                                error: _vm.$v.selectedSubcategories.$error,
                                subcategories: category.subcategories,
                                translations: _vm.translations,
                                "selected-subcategories":
                                  _vm.selectedSubcategories,
                                "max-count": _vm.MAX_CATEGORIES,
                              },
                              model: {
                                value: _vm.selectedSubcategories,
                                callback: function ($$v) {
                                  _vm.selectedSubcategories = $$v
                                },
                                expression: "selectedSubcategories",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              })
            },
          },
        ]),
        model: {
          value: _vm.selectedCategoryId,
          callback: function ($$v) {
            _vm.selectedCategoryId = $$v
          },
          expression: "selectedCategoryId",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }